import API_ENDPOINTS from "../config/apiEndpoints";
import { requestWithAuth } from "./apiClient";

export const apiMotivoAusenciasService = {
  
    create: async(json, empresaId) => {
        const response = await requestWithAuth(API_ENDPOINTS.MOTIVOS.CREATE(empresaId), {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
                     },
            body: JSON.stringify(json),
          });
       
          return response.json();
    },

    getAllByID: async(idEmpresa) => {
      return requestWithAuth(API_ENDPOINTS.MOTIVOS.ALL(idEmpresa), { method: "GET" });
    }    ,
    update: async(json, idEmpresa) => {
        const requestOptions = {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(json),
        };
        const response = await requestWithAuth(API_ENDPOINTS.MOTIVOS.UPDATE(idEmpresa),requestOptions);

        return response.json();
    },
    delete: async(id) => {
        const response = await requestWithAuth(API_ENDPOINTS.MOTIVOS.DELETE(id), {
            method: "DELETE",
        });

        return response;
    }

};
